import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import LoginScreen from "./screens/LoginScreen";
import RegisterScreen from "./screens/RegisterScreen";
import DashboardScreen from "./screens/DashboardScreen";
import ProductScreen from "./screens/ProductScreen";
import ProfileScreen from "./screens/ProfileScreen";
import UserListScreen from "./screens/UserListScreen";
import UserEditScreen from "./screens/UserEditScreen";
import ProductListScreen from "./screens/ProductListScreen";
import ProductCreateScreen from "./screens/ProductCreateScreen";
import ProductEditScreen from "./screens/ProductEditScreen";
import "./App.css";
import Reports from "./screens/Reports";

const App = () => {

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/product/:id" component={ProductScreen} />
        <Route path="/dashboard" component={DashboardScreen} />
        <Route path="/profile" component={ProfileScreen} />
        <Route path="/login" component={LoginScreen} />
        <Route path="/register" component={RegisterScreen} />
        <Route path="/admin/userlist" component={UserListScreen} />
        <Route path="/admin/user/:id/edit" component={UserEditScreen} />
        <Route path="/admin/productlist" component={ProductListScreen} />
        <Route path="/admin/product/create" component={ProductCreateScreen} />
        <Route path="/admin/product/:id/edit" component={ProductEditScreen} />
        <Route path="/" exact component={LoginScreen} />
        <Route path="/admin/product/reports" exact component={Reports} />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
